import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';

export default class GaleriaImagens {
    constructor() {

        this.sections = document.querySelectorAll('.component-galeria_imagens');
        this.ready();
    }

    ready() {

        this.sections.forEach(section => {
            const slider = section.querySelector('.swiper--slider');
            const navigationPrev = section.querySelector('.swiper-container--nav--slider .slider-button-prev');
            const navigationNext = section.querySelector('.swiper-container--nav--slider .slider-button-next');
            const pagination = section.querySelector('.swiper-container--nav--slider .swiper-pagination-nav');

            const swiper = new Swiper(slider, {
                modules: [Navigation, Pagination],
                grabCursor: true,
                spaceBetween: 24,
                allowTouchMove: false,
                navigation: {
                    nextEl: navigationNext,
                    prevEl: navigationPrev,
                },
                pagination: {
                    el: pagination,
                    type: 'fraction',
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.2
                    },
                    640: {
                        slidesPerView: 2.2
                    },
                    1024: {
                        slidesPerView: 3.2
                    },
                    1280: {
                        slidesPerView: 5
                    },

                }
            });

            const sliderModal = section.querySelector('.swiper--slider--modal');
            const navigationPrevModal = section.querySelector('.swiper-container--nav--modal .slider-button-prev');
            const navigationNextModal = section.querySelector('.swiper-container--nav--modal .slider-button-next');
            const paginationModal = section.querySelector('.swiper-container--nav--modal .swiper-pagination-nav');

            const swiperModal = new Swiper(sliderModal, {
                modules: [Navigation, Pagination],
                slidesPerView: 1,
                grabCursor: true,
                spaceBetween: 0,
                allowTouchMove: true,
                navigation: {
                    nextEl: navigationNextModal,
                    prevEl: navigationPrevModal,
                },
                pagination: {
                    el: paginationModal,
                    type: 'fraction',
                }
            });

            const btnsOpenModal = slider.querySelectorAll('.swiper-slide')
            btnsOpenModal.forEach(el => {
                el.addEventListener('click', () => {
                    section.querySelector('.modal--imagens').classList.add('active')
                    swiperModal.slideTo(el.dataset.count, false,false);
                })
            })

            this.modalAction();

        })

    }

    modalAction() {

        document.querySelectorAll('.btnCloseModal').forEach(el => {
            el.addEventListener('click', () => {
                document.querySelector('.modal--imagens.active').classList.remove('active')
            })
        })

    }

}

if (document.querySelector('.component-galeria_imagens')) {
    new GaleriaImagens();
}